import { render } from "./IconQRScan.vue?vue&type=template&id=4fed16e9"
import script from "./IconQRScan.vue?vue&type=script&lang=js"
export * from "./IconQRScan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__